import { Box, Chip, Container, Grid, Typography } from "@mui/material";
import Image1 from "../../slider1.jpg";
import Image2 from "../../slider4.jpg";
import Image3 from "../../slider3.jpg";
import Image4 from "../../slider2.jpg";

export const AboutUs = () => (
  <Box
    id="aboutus"
    sx={{
      width: "100%",
      backgroundColor: "background.default",
      py: { xs: 8, sm: 12 },
      px: { xs: 3, sm: 6 },
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
        {/* Image grid */}
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            {[
              { src: Image1, alt: "Kangoo Jumps class energy" },
              { src: Image2, alt: "Community jumping together" },
              { src: Image3, alt: "Hoppenhagen participants" },
              { src: Image4, alt: "Fun fitness class in Copenhagen" },
            ].map((img, i) => (
              <Grid item xs={6} key={i}>
                <Box
                  component="img"
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  sx={{
                    width: "100%",
                    aspectRatio: "1",
                    objectFit: "cover",
                    borderRadius: 3,
                    display: "block",
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Text content */}
        <Grid item xs={12} md={6}>
          <Chip
            label="Our story"
            size="small"
            sx={{
              bgcolor: "teal.main",
              color: "common.white",
              fontWeight: 700,
              letterSpacing: 0.5,
              mb: 2,
            }}
          />
          <Typography
            component="h2"
            variant="h4"
            sx={{ fontWeight: 900, color: "text.primary", mb: 3 }}
          >
            Born from a love of movement
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: "text.secondary" }}>
            Hoppenhagen was founded by Claudia, who discovered Kangoo Jumps in
            Romania and couldn't find anything like it when she moved to
            Copenhagen. Rather than accept that absence, she trained as a
            certified instructor and started her own classes - first for herself,
            then for a growing community.
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8, color: "text.secondary" }}>
            Today Hoppenhagen is a space where movement feels like release,
            everyone is welcome regardless of fitness level, and the community
            is the product.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  </Box>
);
